import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import './index.scss';
import { RadialProgress } from 'react-radial-progress-indicator';
import * as API from '../../configuration/apiconfig';

var progressBarCounter = null;
export default class IdleStayModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: false,
    };
  }

  componentDidMount = () => {
    this.setState({
      isUserLoggedIn: this.props.userLoggedIn,
    });
  };

  componentDidUpdate = () => {
    // console.log(progressBarCounter, 'progressBarCounter--didmount')
    if (progressBarCounter <= 1 && progressBarCounter != null) {
      this.redirectToHome();
    }

    if (this.props.userLoggedIn !== this.state.isUserLoggedIn) {
      this.setState({
        isUserLoggedIn: this.props.userLoggedIn,
      });
    }
  };

  redirectToHome = () => {
    window.location.href = `/?cinemaid=${localStorage.getItem('cinemaid')}`;
  };

  render() {
    return (
      <>
        <Modal show={this.props.idleStayModalSH} dialogClassName="idle-stay-popup" className="idle-stay-popup-class" centered>
          <Modal.Body>
            <div className="content">
              <p>{this.state.isUserLoggedIn ? 'Do you need more time?' : 'Redirecting to home page in'}</p>
              <div className="progress-sec">
                <RadialProgress
                  // backgroundColour="#dff0d8"
                  backgroundTransparent
                  duration={10000}
                  fontRatio={5}
                  height={100}
                  ringBgColour="#f1f1f1"
                  ringFgColour="#ffc216"
                  ringIntermediateColour="#f1f1f1"
                  ringThickness={0.25}
                  segmented
                  // showIntermediateProgress
                  startStep={10}
                  step={0}
                  steps={10}
                  // text={function text(steps,percentage){return Math.floor(steps*percentage)}}
                  text={function text(steps, percentage) {
                    progressBarCounter = Math.floor(steps * percentage);
                    return Math.floor(steps * percentage);
                  }}
                  width={100}
                />
              </div>
              {this.state.isUserLoggedIn ? (
                <div className="login-reset-btns">
                  <div className="btn-wrap">
                    <a onClick={e => this.props.stayBtnClick(e)} href="javascript:;" className="btn btnPrimary" title="Yes">
                      Yes
                    </a>
                  </div>
                  <div className="btn-wrap no-btn">
                    <a onClick={() => this.redirectToHome()} href="javascript:;" className="btn btnPrimary" title="No">
                      No
                    </a>
                  </div>
                </div>
              ) : (
                <div className="btn-wrap">
                  <a onClick={e => this.props.stayBtnClick(e)} href="javascript:;" className="btn btnPrimary" title="Stay on this page">
                    Stay on this page
                  </a>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
